import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { EditOutlined, DragOutlined, MoreOutlined } from '@ant-design/icons'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'

function VideoItem(props) {
  const { el, setVisible, setActiveItem } = props
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: el.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  // Get display name from data.name
  const getDisplayName = () => {
    if (el.data) {
      if (typeof el.data === 'string') {
        try {
          const parsed = JSON.parse(el.data)
          return parsed?.name || ''
        } catch {
          return ''
        }
      }
      return el.data?.name || ''
    }
    return ''
  }

  const displayName = getDisplayName()

  // Get video URL from data.src
  const getVideoUrl = () => {
    if (el.data) {
      if (typeof el.data === 'string') {
        try {
          const parsed = JSON.parse(el.data)
          return parsed?.src || ''
        } catch {
          return ''
        }
      }
      return el.data?.src || ''
    }
    return ''
  }

  const videoUrl = getVideoUrl()

  const handleEdit = () => {
    setActiveItem(el)
    setVisible(true)
  }

  const handleViewVideo = () => {
    if (videoUrl) {
      window.open(videoUrl, '_blank')
    }
  }

  const handleAddBefore = () => {
    setActiveItem({
      actionType: 'add',
      mediaType: 'video',
      xExperienceId: el.xExperienceId,
      insertPosition: 'before',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const handleAddAfter = () => {
    setActiveItem({
      actionType: 'add',
      mediaType: 'video',
      xExperienceId: el.xExperienceId,
      insertPosition: 'after',
      referenceOrderNumber: el.orderNumber,
    })
    setVisible(true)
  }

  const menu = (
    <Menu>
      <Menu.Item key="addBefore" onClick={handleAddBefore}>
        Add Video Before
      </Menu.Item>
      <Menu.Item key="addAfter" onClick={handleAddAfter}>
        Add Video After
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="viewVideo" onClick={handleViewVideo}>
        View Video
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        data-id={el.id}
        className="inventory-row"
      >
        <div className="inventory-row-drag-handle" {...listeners}>
          <DragOutlined />
        </div>
        <div className="inventory-row-content">
          <div className="inventory-row-display-name">{displayName}</div>
          <div
            className="inventory-row-internal-name"
            style={{ fontSize: '12px', color: '#8c8c8c' }}
          >
            {videoUrl}
          </div>
        </div>
        <div className="inventory-row-actions">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={handleEdit}
            className="inventory-row-edit-btn"
          />
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type="text"
              icon={<MoreOutlined />}
              className="inventory-row-more-btn"
            />
          </Dropdown>
        </div>
      </div>
    </>
  )
}
export default VideoItem
